export default IconCurrencyEuroOff => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-currency-euro-off" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M17.2 7c-1.977 -2.26 -4.954 -2.602 -7.234 -1.04m-1.913 2.079c-1.604 2.72 -1.374 6.469 .69 8.894c2.292 2.691 6 2.758 8.356 .18" />
  <path d="M10 10h-5m0 4h8" />
  <path d="M3 3l18 18" />
</svg>`;